import { createContext, useContext } from 'react';

/* Whether the root of a Dialog, Sheet or SidePanel is modal. Base UI skips the backdrop of a
   dialog nested in another unless forced; the DS forces it so a modal over a drawer veils the
   drawer, but only for a modal root: over a non-modal one (`modal={false}` or `'trap-focus'`)
   the veil would block the clicks the root means to let through. Base UI exposes no hook to read
   the root's `modal`, so the DS roots publish it here. */
export const ModalRoot = createContext<boolean | 'trap-focus'>(true);

/** The backdrop's `forceRender`: forced over a modal root, Base UI's default otherwise. */
export function useForceVeil(): boolean {
  return useContext(ModalRoot) === true;
}

/** Whether the surface mounts a veil at all. A non-modal root (`modal={false}`) mounts none: Base UI
 *  still draws an un-nested backdrop for it, which would cover and block the page the root means to
 *  leave usable (the pushed conversation, the voucher list). `'trap-focus'` keeps the veil. */
export function useShowsVeil(): boolean {
  return useContext(ModalRoot) !== false;
}
